export default function verifyArray(array) {
  return array && array.length > 0 ? true : false;
}
